module.exports = __webpack_public_path__ + "static/img/7.893c5e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/7.png
// module id = H2VO
// module chunks = 0